import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-item-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './item-modal.component.html',
  styleUrl: './item-modal.component.css',
})
export class ItemModalComponent {
  @Input() item: any; // Recibe el item a editar/eliminar
  @Input() isOpen: boolean = false; // Controla si el modal está abierto
  @Input() title: string = 'Editar'; // Título dinámico
  @Input() fields: {
    key: string;
    label: string;
    type: string;
    min_date?: string;
    options?: any[];
  }[] = []; // Campos a mostrar
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  originalItem: any = {}; // Copia del item original
  showPassword: boolean = false;
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.originalItem = { ...this.item }; // Guardar copia del estado original
  }

  closeModal() {
    this.close.emit();
  }

  updateItem() {
    this.save.emit(this.item);
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // Alternar la visibilidad de la contraseña
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
